import React, { createContext, useState, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [currentTheme, setCurrentTheme] = useState('beach');

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  const changeTheme = (theme) => {
    setCurrentTheme(theme);
  };

  const themes = {
    beach: {
      name: 'Beach',
      type: 'beach',
      bgImage: 'https://cdn.pixabay.com/photo/2019/09/16/19/52/beach-4481919_1280.jpg',
      bgColor: '#e6f7ff',
      buttonColor: '#03a9f4',
      cardBg: '#E0FFFF',
      textColor: '#006994',
      accentColor: '#20B2AA'
    },
    mountain: {
      name: 'Forest',
      type: 'mountain',
      bgImage: 'https://cdn.pixabay.com/photo/2022/04/22/17/33/forest-7150274_1280.jpg',
      bgColor: '#e8f5e9',
      buttonColor: '#4caf50',
      cardBg: '#F0FFF0',
      textColor: '#228B22',
      accentColor: '#6B8E23'
    },
    desert: {
      name: 'Desert',
      type: 'desert',
      bgImage: 'https://cdn.pixabay.com/photo/2021/11/20/13/47/sky-6811874_1280.jpg',
      bgColor: '#ffecd1',
      buttonColor: '#ff9800',
      cardBg: '#FFF8DC',
      textColor: '#8B4513',
      accentColor: '#DAA520'
    },
    snow: {
      name: 'Snow',
      type: 'snow',
      bgImage: 'https://cdn.pixabay.com/photo/2018/05/04/07/55/snow-3373432_1280.jpg',
      bgColor: '#e0f3ff',
      buttonColor: '#4a90e2',
      cardBg: '#ffffff',
      textColor: '#333333',
      accentColor: '#87CEEB'
    },
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleDarkMode, currentTheme, changeTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;